import React from "react";

interface MagazineCardProps {
  month: string;
  image: string;
  pdfUrl: string;
}

const MagazineCard: React.FC<MagazineCardProps> = ({ month, image, pdfUrl }) => {
  return (
    <a
      href={pdfUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block transition-transform duration-200 hover:scale-105"
    >
      <div className="relative group text-center min-w-[180px] max-w-[180px] mx-auto">
        {/* Imagen con efecto oscuro al hover */}
         {/* cambio forzado */}
        <img
          src={image}
          alt={`Portada ${month}`}
          className="rounded-md  w-full h-auto object-cover transition duration-300 group-hover:brightness-75"
        />
        <p className="text-sm text-[#B9C5D5] font-light mt-2">{month}</p>
      </div>
    </a>
  );
};

export default MagazineCard;
